import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Authorization } from "../../../Context/Authorization";
import Table from "react-bootstrap/Table";
import Preloader from "../../../shared/PreLoaders";

const CircleLoanAmount = () => {
  const { circleId } = useParams();
  const [divisionData, setDivisionData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const Api = process.env.REACT_APP_API;
  const [circleName, setCircleName] = useState("");
  const LOCAL_KEY = `CircleTotalLoanAmountDataCache_${circleId}`;
  const [departmentSummary, setDepartmentSummary] = useState({});

  const saveToLocalCache = (circleName, divisionList, summary) => {
    localStorage.setItem(
      LOCAL_KEY,
      JSON.stringify({
        circleName,
        divisionList,
        summary,
        timestamp: new Date().toISOString(),
      })
    );
  };

  const loadFromLocalCache = () => {
    const cached = localStorage.getItem(LOCAL_KEY);
    return cached ? JSON.parse(cached) : null;
  };

  const fetchDivisionData = async () => {
    try {
      const config = Authorization();
      const res = await axios.get(
        `${Api}/api/drill/loan/circle-loans/${circleId}`,
        config
      );

      setCircleName(res.data.circleName);
      setDivisionData(res.data.data);

      // Directly use the full summary from API
      setDepartmentSummary(res.data.summary);

      // Save circleName, data list and FULL summary
      saveToLocalCache(res.data.circleName, res.data.data, res.data.summary);
    } catch (error) {
      console.error(
        "Error fetching division-wise department loan data:",
        error
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    const cached = loadFromLocalCache();
    if (cached && cached.divisionList) {
      setCircleName(cached.circleName || "");
      setDivisionData(cached.divisionList);
      setDepartmentSummary(cached.summary || {});
      setLoading(false);
    } else {
      fetchDivisionData();
    }
  }, [Api, circleId]);

  const formatDateTime = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleString("en-IN", { timeZone: "Asia/Kolkata" });
  };
  const formatAmount = (amount) => {
    if (amount >= 10000000) {
      return (amount / 10000000).toFixed(2) + " Cr"; // Crores
    } else if (amount >= 100000) {
      return (amount / 100000).toFixed(2) + " L"; // Lakhs
    } else if (amount >= 1000) {
      return (amount / 1000).toFixed(2) + " K"; // Thousands
    }
    return amount; // Return as is if less than 1000
  };
  if (loading) return <Preloader loading={true} />;

  return (
    <div>
      <div className="page-header">
        <h3 className="page-title">{circleName} Circle - Department Loan</h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li
              className="breadcrumb-item"
              style={{
                color: "blue",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => navigate(-1)}
            >
              ← Back
            </li>
            <li
              className="breadcrumb-item active"
              style={{ color: "red", cursor: "pointer" }}
              onClick={() => navigate("/dashboard")}
            >
              🏠 Home
            </li>
          </ol>
        </nav>
      </div>

      <div className="d-flex justify-content-between align-items-center mb-3 px-2">
        <button
          className="btn btn-sm btn-outline-secondary"
          onClick={() => {
            localStorage.removeItem(LOCAL_KEY);
            setLoading(true);
            fetchDivisionData();
          }}
        >
          🔄 Refresh Now
        </button>
        <div className="text-muted small">
          Last Refreshed:{" "}
          {loadFromLocalCache()?.timestamp
            ? formatDateTime(loadFromLocalCache().timestamp)
            : "Not Available"}
        </div>
      </div>

      <div className="col-md-12 stretch-card grid-margin">
        <div className="card bg-gradient-OceanDusk card-img-holder text-white">
          <div className="card-body">
            <img
              src={require("../../../../assets/images/dashboard/circle.png")}
              className="card-img-absolute"
              alt="circle"
              style={{ pointerEvents: "none" }}
            />
            <h4 className="font-weight-normal mb-3">{circleName} Circle</h4>
            <h1>
              Loan Amount - ₹
              {formatAmount(departmentSummary.totalDepartmentLoanAmount || 0)}
            </h1>
          </div>
        </div>
      </div>

      <h4 className="mb-3">Division-wise Department Loan Summary</h4>

      <Table striped bordered hover className="mt-2 text-center">
        <thead>
          <tr>
            <th>#</th>
            <th>Division</th>
            <th>Male Beneficiaries</th>
            <th>Female Beneficiaries</th>
            <th>Third Gender Beneficiaries</th>
            <th>Amount Disbursed</th>
          </tr>
        </thead>
        <tbody>
          {divisionData
            .sort((a, b) => a.divisionName.localeCompare(b.divisionName))
            .map((division, index) => (
              <tr key={division.divisionId}>
                <td>{index + 1}</td>
                <td
                  style={{
                    color: "blue",
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    navigate(`/drill/division-amount/${division.divisionId}`)
                  }
                >
                  {division.divisionName}
                </td>
                <td>{division.departmentLoan?.male || 0}</td>
                <td>{division.departmentLoan?.female || 0}</td>
                <td>{division.departmentLoan?.others || 0}</td>
                <td>
                  ₹{(division.departmentLoanAmount || 0).toLocaleString("en-IN")}
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
    </div>
  );
};

export default CircleLoanAmount;
